var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _rect3, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueberry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.418 168.939L119.445 169.6L122.583 207.47L130.555 206.81L127.418 168.939Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172 169.2H164V207.2H172V169.2Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_72",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 220,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 220,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.5 232.2C171.972 232.2 191 229.961 191 227.2C191 224.439 171.972 222.2 148.5 222.2C125.028 222.2 106 224.439 106 227.2C106 229.961 125.028 232.2 148.5 232.2Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 225.2C128.165 225.2 136 220.275 136 214.2C136 208.125 128.165 203.2 118.5 203.2C108.835 203.2 101 208.125 101 214.2C101 220.275 108.835 225.2 118.5 225.2Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 225.2C186.165 225.2 194 220.275 194 214.2C194 208.125 186.165 203.2 176.5 203.2C166.835 203.2 159 208.125 159 214.2C159 220.275 166.835 225.2 176.5 225.2Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_72",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 207,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.5 214.2C109.881 214.2 111 213.081 111 211.7C111 210.319 109.881 209.2 108.5 209.2C107.119 209.2 106 210.319 106 211.7C106 213.081 107.119 214.2 108.5 214.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_72",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 207,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 214.2C188.881 214.2 190 213.081 190 211.7C190 210.319 188.881 209.2 187.5 209.2C186.119 209.2 185 210.319 185 211.7C185 213.081 186.119 214.2 187.5 214.2Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 116.2L101.2 123.4C101.1 125.9 99 127.8 96.5 127.7C94 127.6 92.1 125.5 92.2 123L92.5 115.8C92.6 113.3 94.7 111.4 97.2 111.5C99.7 111.6 101.6 113.7 101.5 116.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.1 82C116.1 83.5 115.5 84.8 114.6 85.8C114.2 86.1 113.9 86.3 113.6 86.6C109.3 90.4 106.2 95.6 105.1 101.5C105 101.8 105 102.1 104.9 102.4C104.3 104.7 102.1 106.4 99.6 106.4C96.8 106.4 94.6 104.4 94.2 101.8C94.2 101.4 94.1 101 94.1 100.6C94.1 100.4 94.1 100.1 94.1 99.9C94.1 90.3 99.4 81.9 107.4 77.4C107.8 77.2 108.2 76.9 108.7 76.7C109.3 76.5 110 76.3 110.6 76.3C113.6 76.5 116.1 79 116.1 82Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.7 191.8C182.464 191.8 214.7 159.564 214.7 119.8C214.7 80.0355 182.464 47.8 142.7 47.8C102.935 47.8 70.7 80.0355 70.7 119.8C70.7 159.564 102.935 191.8 142.7 191.8Z",
    fill: "#513880"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.7 157.6C148.081 157.6 149.2 156.481 149.2 155.1C149.2 153.719 148.081 152.6 146.7 152.6C145.319 152.6 144.2 153.719 144.2 155.1C144.2 156.481 145.319 157.6 146.7 157.6Z",
    fill: "#331F61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 142.6C176.581 142.6 177.7 141.481 177.7 140.1C177.7 138.719 176.581 137.6 175.2 137.6C173.819 137.6 172.7 138.719 172.7 140.1C172.7 141.481 173.819 142.6 175.2 142.6Z",
    fill: "#331F61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 108.6C176.581 108.6 177.7 107.481 177.7 106.1C177.7 104.719 176.581 103.6 175.2 103.6C173.819 103.6 172.7 104.719 172.7 106.1C172.7 107.481 173.819 108.6 175.2 108.6Z",
    fill: "#331F61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 125.6C153.581 125.6 154.7 124.481 154.7 123.1C154.7 121.719 153.581 120.6 152.2 120.6C150.819 120.6 149.7 121.719 149.7 123.1C149.7 124.481 150.819 125.6 152.2 125.6Z",
    fill: "#331F61"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.2 141.6C126.581 141.6 127.7 140.481 127.7 139.1C127.7 137.719 126.581 136.6 125.2 136.6C123.819 136.6 122.7 137.719 122.7 139.1C122.7 140.481 123.819 141.6 125.2 141.6Z",
    fill: "#331F61"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 139.6C92.5807 139.6 93.7 138.481 93.7 137.1C93.7 135.719 92.5807 134.6 91.2 134.6C89.8193 134.6 88.7 135.719 88.7 137.1C88.7 138.481 89.8193 139.6 91.2 139.6Z",
    fill: "#331F61"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.2 118.6C104.581 118.6 105.7 117.481 105.7 116.1C105.7 114.719 104.581 113.6 103.2 113.6C101.819 113.6 100.7 114.719 100.7 116.1C100.7 117.481 101.819 118.6 103.2 118.6Z",
    fill: "#331F61"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2 102.6C91.5807 102.6 92.7 101.481 92.7 100.1C92.7 98.7193 91.5807 97.6 90.2 97.6C88.8193 97.6 87.7 98.7193 87.7 100.1C87.7 101.481 88.8193 102.6 90.2 102.6Z",
    fill: "#331F61"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.2 107.6C133.581 107.6 134.7 106.481 134.7 105.1C134.7 103.719 133.581 102.6 132.2 102.6C130.819 102.6 129.7 103.719 129.7 105.1C129.7 106.481 130.819 107.6 132.2 107.6Z",
    fill: "#331F61"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.2 83.6C117.581 83.6 118.7 82.4807 118.7 81.1C118.7 79.7193 117.581 78.6 116.2 78.6C114.819 78.6 113.7 79.7193 113.7 81.1C113.7 82.4807 114.819 83.6 116.2 83.6Z",
    fill: "#331F61"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 92.6C153.581 92.6 154.7 91.4807 154.7 90.1C154.7 88.7193 153.581 87.6 152.2 87.6C150.819 87.6 149.7 88.7193 149.7 90.1C149.7 91.4807 150.819 92.6 152.2 92.6Z",
    fill: "#331F61"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2 71.6C164.581 71.6 165.7 70.4807 165.7 69.1C165.7 67.7193 164.581 66.6 163.2 66.6C161.819 66.6 160.7 67.7193 160.7 69.1C160.7 70.4807 161.819 71.6 163.2 71.6Z",
    fill: "#331F61"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.2 56.6C150.581 56.6 151.7 55.4807 151.7 54.1C151.7 52.7193 150.581 51.6 149.2 51.6C147.819 51.6 146.7 52.7193 146.7 54.1C146.7 55.4807 147.819 56.6 149.2 56.6Z",
    fill: "#331F61"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.2 168.6C117.581 168.6 118.7 167.481 118.7 166.1C118.7 164.719 117.581 163.6 116.2 163.6C114.819 163.6 113.7 164.719 113.7 166.1C113.7 167.481 114.819 168.6 116.2 168.6Z",
    fill: "#331F61"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.2 181.6C130.581 181.6 131.7 180.481 131.7 179.1C131.7 177.719 130.581 176.6 129.2 176.6C127.819 176.6 126.7 177.719 126.7 179.1C126.7 180.481 127.819 181.6 129.2 181.6Z",
    fill: "#331F61"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M213.7 119.4C213.7 159.2 181.5 191.4 141.7 191.4C139.6 191.4 137.4 191.3 135.3 191.1C164.5 184 186.7 148.1 186.7 104.9C186.7 86.9 182.8 70.1 176.2 56.2C198.6 68.4 213.7 92.1 213.7 119.4Z",
    fill: "#331F61"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 60.6C133.357 60.6 134.7 59.7045 134.7 58.6C134.7 57.4954 133.357 56.6 131.7 56.6C130.043 56.6 128.7 57.4954 128.7 58.6C128.7 59.7045 130.043 60.6 131.7 60.6Z",
    fill: "#009D00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135.7 61.6C137.357 61.6 138.7 60.7045 138.7 59.6C138.7 58.4954 137.357 57.6 135.7 57.6C134.043 57.6 132.7 58.4954 132.7 59.6C132.7 60.7045 134.043 61.6 135.7 61.6Z",
    fill: "#009D00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 64.6C136.357 64.6 137.7 63.7045 137.7 62.6C137.7 61.4954 136.357 60.6 134.7 60.6C133.043 60.6 131.7 61.4954 131.7 62.6C131.7 63.7045 133.043 64.6 134.7 64.6Z",
    fill: "#009D00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130.7 65.6C132.357 65.6 133.7 64.7045 133.7 63.6C133.7 62.4954 132.357 61.6 130.7 61.6C129.043 61.6 127.7 62.4954 127.7 63.6C127.7 64.7045 129.043 65.6 130.7 65.6Z",
    fill: "#009D00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 62.6C130.357 62.6 131.7 61.7045 131.7 60.6C131.7 59.4954 130.357 58.6 128.7 58.6C127.043 58.6 125.7 59.4954 125.7 60.6C125.7 61.7045 127.043 62.6 128.7 62.6Z",
    fill: "#009D00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 62.6C133.357 62.6 134.7 61.7045 134.7 60.6C134.7 59.4954 133.357 58.6 131.7 58.6C130.043 58.6 128.7 59.4954 128.7 60.6C128.7 61.7045 130.043 62.6 131.7 62.6Z",
    fill: "#009D00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149 101.9C149 98.3 151.9 95.4 155.5 95.4C159.1 95.4 162 98.3 162 101.9",
    fill: "#FFF3F3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119 101.9C119 98.3 121.9 95.4 125.5 95.4C129.1 95.4 132 98.3 132 101.9",
    fill: "#FFF3F3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.3 112.6C152.3 118.7 147.4 123.6 141.3 123.6C135.2 123.6 130.3 118.7 130.3 112.6",
    fill: "#FFF3F3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6 118.1C78.6 118.1 58.9 148.4 67.4 170.3",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M202.4 128.8C202.4 128.8 211.4 163.8 196.4 181.8",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_72",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_72",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_72",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_72",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGoAAACBgAAAs3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACKAAACAwEBAAAAAAAAAAAAAAAABQEEBgMCAQEAAAAAAAAAAAAAAAAAAAAAEAAABwACAwEAAAAAAAAAAAAAAQIDBAUGBxcQIBEWEQABAgMFBgMJAAAAAAAAAAABAAIRAwQx0RKSBSFBkbET0xBSk1FhobJjgyRENRIBAAAAAAAAAAAAAAAAAAAAIP/aAAwDAQACEQMRAAAAx+oyeiHVpd6L5EgFM6Uey4RqmC8//9oACAECAAEFAPb/2gAIAQMAAQUA9v/aAAgBAQABBQCrpZdmuHxpIcKPxlCQvrikHXFGOuKMdcUY64oxJ4zr1nJ4yUlu1zs2s8QHLRs41zu2m0arZpSWs2JGnXXfz9fcg9fch3Wa01nq9kZSLzduCe7dOEP/2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AAJOFrYwLnXLFUVIDTZgEOcVGfUPmN8tnIBWvzG9WvzG9WvzG9WvzG9WvzG9AyJ75QFotjmii6nqiXjzAQ+EETMLXsG8W8PAmgE0n6bS7kCmtl0lS8DeaeYY8AgDotQ4+3oze2tuh1B+zN7aGLQq2O+Eh9y/g13oPuWzQa70H3I9LQ6kM3YpM2PyKA0WoHv6M3tp2KiqGNMf15uwcF+eJwG/qMLByHh//9k="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_72",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF4AAABiQAAAbX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABsAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAQAAAAAAAAAAAAAAAAAFEAMEBhEAAQIHAAAAAAAAAAAAAAAAAhIDIAERQSJCBBIBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAAAAz0AP/9oACAECAAEFAD//2gAIAQMAAQUAP//aAAgBAQABBQDGuS2c7P8A/9oACAECAgY/AH//2gAIAQMCBj8Af//aAAgBAQEGPwB7tfcT3AqQiq+uNYP/2Q=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueberry);
export default __webpack_public_path__ + "static/media/blueberry.4779f1cbb66a19947db8b0648bb46a4b.svg";
export { ForwardRef as ReactComponent };